const getMoviePrice = (movie: any, type: string) => {
  if (movie.promo_prices && movie.promo_prices[type]) {
    if (movie.promotion_only_downloads) {
      return type.includes('download') ? movie.promo_prices[type].price : movie[type].price;
    }
    return movie.promo_prices[type].price;
  }
  return movie[type].price;
};

export default getMoviePrice